import { h } from '@stencil/core';
import { GLOBAL_ANALYTICS_EVENT_NAME, FILTER_STATE_CHANGED_EVENT_NAME } from '@pes-ui/utils';
import { html2plain } from '../../globals/utils/helpers';
export class RangePills {
  constructor() {
    this.handleClickClose = (navigationState, value, unCheckedURL) => {
      this.pillsEl.dispatchEvent(new CustomEvent(GLOBAL_ANALYTICS_EVENT_NAME, {
        detail: {
          event: FILTER_STATE_CHANGED_EVENT_NAME,
          isChecked: false,
          refinementId: `${value}_${navigationState}`,
        },
        bubbles: true,
        composed: true,
      }));
      this.removePill.emit(unCheckedURL);
    };
    this.pills = [];
  }
  render() {
    var _a;
    if (!((_a = this.pills) === null || _a === void 0 ? void 0 : _a.length))
      return null;
    return (h("div", { class: "pills", ref: (el) => {
        this.pillsEl = el;
      } }, this.pills.map((item) => (h("pes-tooltip-wrapper", { class: "pill", position: "top", key: `${item === null || item === void 0 ? void 0 : item.charValueId}_${item === null || item === void 0 ? void 0 : item.navigationState}` }, h("qds-chip", { slot: "tooltip-activator", type: "closable", text: html2plain(item.label), onQdsClose: () => this.handleClickClose(item === null || item === void 0 ? void 0 : item.navigationState, item === null || item === void 0 ? void 0 : item.charValueId, item === null || item === void 0 ? void 0 : item.unCheckedURL) }), h("div", { slot: "tooltip-content", class: "pills__tooltip" }, item.characteristicName))))));
  }
  static get is() { return "pes-range-filter-pills"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-range-filter-pills.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-range-filter-pills.css"]
    };
  }
  static get properties() {
    return {
      "pills": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductsPillsData[]",
          "resolved": "TProductsPillsData[]",
          "references": {
            "TProductsPillsData": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "[]"
      }
    };
  }
  static get events() {
    return [{
        "method": "removePill",
        "name": "removePill",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        }
      }];
  }
}
